import React from "react";

function RatingSymbol(){
    return <img src="/star.svg" alt="Rating" style={{width: '16px', height: '16px'}} />
}

export default RatingSymbol
